import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import PageProjectsActiveResources from 'hcp/components/page/projects/active-resources';

<template>
  {{pageTitle (t "page-title.projects.active-resources")}}
  <BreadcrumbsItem
    @route="cloud.orgs.detail.projects.detail.active-resources"
    @text={{t "components.page.projects.active-resources.title"}}
  />

  <PageProjectsActiveResources @model={{@controller.model}} />
</template>
